// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-ux-displayexd .x-form-display-field-default {\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/libs/owns/Ext.ux.form.field.DisplayExd/Ext.ux.form.field.DisplayExd.css"],"names":[],"mappings":"AAAA;AACA","sourcesContent":[".x-ux-displayexd .x-form-display-field-default {\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
